/** Lo que dice la tarjeta de notificaciones, sin React: se prueba solo. */

export type EstadoDispositivo =
  | 'sin-cuenta'
  | 'no-disponible'
  | 'instalar'
  | 'no-soportado'
  | 'bloqueadas'
  | 'activadas'
  | 'desactivadas';

export function estadoDispositivo(e: {
  conCuenta: boolean;
  disponible: boolean;
  soportado: boolean;
  permiso: NotificationPermission | 'no-soportado';
  ios: boolean;
  instalada: boolean;
  suscrito: boolean;
}): EstadoDispositivo {
  if (!e.conCuenta) return 'sin-cuenta';
  if (!e.disponible) return 'no-disponible';
  // En iPhone, Web Push solo existe con la app en la pantalla de inicio.
  if (e.ios && !e.instalada) return 'instalar';
  if (!e.soportado) return 'no-soportado';
  if (e.permiso === 'denied') return 'bloqueadas';
  if (e.permiso === 'granted' && e.suscrito) return 'activadas';
  return 'desactivadas';
}

export const TEXTO_ESTADO: Record<EstadoDispositivo, string> = {
  'sin-cuenta':
    'Con la app cerrada, los avisos necesitan una cuenta: es el servidor quien los envía.',
  'no-disponible': 'Las notificaciones no están disponibles en este servidor.',
  instalar: 'En iPhone llegan con la app instalada: Compartir → «Añadir a pantalla de inicio».',
  'no-soportado': 'Este navegador no puede recibir notificaciones push.',
  bloqueadas: 'Bloqueadas por el sistema. Actívalas en los ajustes del navegador para este sitio.',
  activadas: 'Activadas en este dispositivo.',
  desactivadas: 'Desactivadas en este dispositivo.',
};

export function vistaPrevia(discretas: boolean): { titulo: string; cuerpo: string } {
  return discretas
    ? { titulo: 'selflevel', cuerpo: 'Tienes un hábito pendiente' }
    : { titulo: 'Meditar', cuerpo: 'Son las 7:00' };
}

/** La clave pública VAPID viene en base64url; `pushManager.subscribe` la quiere en bytes. */
export function claveABytes(base64url: string): Uint8Array<ArrayBuffer> {
  const relleno = '='.repeat((4 - (base64url.length % 4)) % 4);
  const base64 = (base64url + relleno).replace(/-/g, '+').replace(/_/g, '/');
  return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
}

/** «Ahora no» en Hoy: una semana sin volver a preguntar. */
const POSPONER_MS = 7 * 86_400_000;

export function posponerAvisos(ahoraMs: number): number {
  return ahoraMs + POSPONER_MS;
}

/**
 * Si Hoy pide activar los avisos. Solo cuando se puede y no se ha dicho ya que no:
 * con el permiso bloqueado no se insiste (el sistema no volvería a preguntar), y en
 * iPhone sin instalar se explica cómo, porque ahí no hay permiso que pedir.
 */
export function ofrecerEnHoy(
  estado: EstadoDispositivo,
  pospuestoHasta: number | null,
  ahoraMs: number,
): 'activar' | 'instalar' | null {
  if (pospuestoHasta !== null && pospuestoHasta > ahoraMs) return null;
  if (estado === 'desactivadas') return 'activar';
  if (estado === 'instalar') return 'instalar';
  return null;
}
